import { render, staticRenderFns } from "./GameRecordDetail.vue?vue&type=template&id=5011620e&scoped=true"
import script from "./GameRecordDetail.vue?vue&type=script&lang=js"
export * from "./GameRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./GameRecordDetail.vue?vue&type=style&index=0&id=5011620e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5011620e",
  null
  
)

export default component.exports